import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "app/models/app-filter.model";
import { Recurso } from "app/models/recurso.model";
import { AbRecursoHub } from "app/abstract/full-pages/hub/recurso-hub.abstract";

@Injectable({ providedIn: 'root' })
export class RecursoHubService extends AbRecursoHub {
    prefixo = "recursos";

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativar(id: number) {
        return this.delete(`${this.prefixo}/`, id);
    }

    public getAllRecursos(filter: AppFilter) {
        return this.get(`${this.prefixo}/filter/${filter.encode()}`);
    }

    public getAllDispositivo(dispositivoId: number) {
        return this.get(`${this.prefixo}/all/`, dispositivoId);
    }

    public getRecurso(id: number) {
        return this.get(`${this.prefixo}/`, id);
    }

    public saveRecurso(recurso: Recurso): Observable<Recurso> {
        return this.save(`${this.prefixo}/`, recurso);
    }

    public saveListaRecurso(recurso: Recurso[]): Observable<boolean> {
        return this.save(`${this.prefixo}/list/`, recurso);
    }

    public ListByDivisao(divisaoId: number) {
        return this.get('recursos_divisoes_areas/divisoes/', divisaoId).toPromise();
    }

    public ListByArea(areaId: number) {
        return this.get('recursos_divisoes_areas/areas/', areaId).toPromise();
    }

}